<template>
  <div class="zw-product-details">
    <!--背景头部-->
    <div class="zw-prosut-detail-head">
      <div class="zw-detail-head-top">
        <div class="zw-detail-head-left">
          <div class="zw-head-lf-top">
            {{ detailsObject.fullName }}
          </div>
          <div class="zw-head-lf-title">
            {{ detailsObject.overview }}
          </div>
          <span class="zw-head-lf-expla">
            {{ detailsObject.description }}
          </span>
          <div class="zw-head-lf-btn">
            <el-button
              type="primary"
              round
              @click="onFreeTrialClick"
            >免费体验</el-button>
            <el-button
              style="margin-left: 32px"
              type="primary"
              round
              plain
              @click="onPresentaClick"
            >申请演示</el-button>
          </div>
        </div>
        <div class="zw-detail-head-right">
          <div v-if="detailsObject.topImage2" class="zw-detail-head-right-img">
            <img
              :src="pictureBaseUrl + detailsObject.topImage2"
              width="70%"
              height="75%"
              alt=""
            >
          </div>
          <img
            v-else
            :src="pictureBaseUrl + detailsObject.topImage"
            width="100%"
            height="100%"
            alt=""
          >
        </div>
      </div>
      <div class="zw-detail-head-core">
        <div class="zw-core-container">
          <!-- 左侧价值点 -->
          <div class="zw-core-left">
            <div v-for="(item, index) in leftValues" :key="index" class="zw-core-item">
              <div class="zw-core-item-title">{{ item.title }}</div>
              <div class="zw-core-item-desc">{{ item.description }}</div>
            </div>
          </div>
          <!-- 中间标题 -->
          <div class="zw-core-center">
            <img class="zw-core-image" src="@/assets/image/details/detail_01.png">
          </div>
          <!-- 右侧价值点 -->
          <div class="zw-core-right">
            <div v-for="(item, index) in rightValues" :key="index" class="zw-core-item">
              <div class="zw-core-item-title">{{ item.title }}</div>
              <div class="zw-core-item-desc">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--产品背景-->
    <div class="zw-product-bg zw-product-matter">
      <div class="zw-matter-title">
        <img src="@/assets/image/product/fourLeft.png">
        <span>产品背景</span>
        <img src="@/assets/image/product/fourRight.png">
      </div>
      <div class="zw-matter-declare">
        {{ detailsObject.backgroundDes }}
      </div>
      <div class="zw-bg-list">
        <!-- 左侧：政策支持 -->
        <div class="zw-policy-section">
          <div class="zw-section-title">{{ detailsObject.backgroundLeftTitle }}</div>
          <div class="zw-section-desc">
            {{ detailsObject.backgroundLeftDescription }}
          </div>
          <!-- 模拟网页内容 -->
          <div class="swiper-container">
            <!-- 轮播图列表 -->
            <div class="swiper-wrapper">
              <div v-for="item in list" :key="item" class="swiper-slide">
                <img :src="pictureBaseUrl + item" alt="">
              </div>
            </div>
            <!-- 分页器（小圆点）可选 -->
            <div class="swiper-pagination" />
            <!-- 左右箭头 可选 -->
            <div class="zw-swiper-prev">
              <i class="el-icon-arrow-left" />
            </div>
            <div class="zw-swiper-next">
              <i class="el-icon-arrow-right" />
            </div>
          </div>
        </div>
        <!-- 右侧：业务痛点 -->
        <div class="zw-pain-section">
          <div class="zw-section-title">{{ detailsObject.backgroundRightTitle }}</div>
          <div class="zw-pain-grid">
            <div v-for="(item, index) in painPoints" :key="index" class="zw-pain-card">
              <div class="zw-pain-title">{{ item.title }}</div>
              <div class="zw-pain-desc">{{ item.description }}</div>
              <img
                style="width: 120px;position: absolute;right: 24px;top:14px"
                src="@/assets/image/details/ywtdIcon.png"
              >
            </div>
          </div>
          <!-- 底部按钮 -->
          <div class="zw-head-lf-btn">
            <el-button
              type="primary"
              round
              @click="onExperProgram"
            >体验产品</el-button>
            <el-button
              style="margin-left: 32px"
              type="primary"
              round
              plain
              @click="onPresentaClick"
            >申请演示</el-button>
          </div>
        </div>
      </div>
    </div>
    <!--系统架构-->
    <div class="zw-system-archite zw-product-matter">
      <div class="zw-matter-title">
        <img src="@/assets/image/product/fourLeft.png">
        <span>系统架构</span>
        <img src="@/assets/image/product/fourRight.png">
      </div>
      <div class="zw-matter-declare">
        {{ detailsObject.arcDescription }}
      </div>
      <div class="zw-system-img">
        <img
          style="width: 68%"
          :src="pictureBaseUrl + detailsObject.arcFile"
        >
      </div>
    </div>
    <!--核心功能模块-->
    <div class="zw-core-fun zw-product-matter">
      <div class="zw-matter-title">
        <img src="@/assets/image/product/fourLeft.png">
        <span>核心功能模块</span>
        <img src="@/assets/image/product/fourRight.png">
      </div>
      <div class="zw-matter-declare">
        {{ detailsObject.coreModuleDescription }}
      </div>
      <div class="zw-core-fun-list">
        <!-- 顶部标签导航 -->
        <div class="zw-fun-tabs">
          <div
            v-for="(tab, index) in funTabData"
            :key="index"
            :class="['zw-fun-tab', { 'zw-fun-tab-active': activeTab === index }]"
            @click="activeTab = index"
          >
            {{ tab.title }}
          </div>
        </div>
        <!-- 内容区域 -->
        <div class="zw-fun-content-wrapper">
          <transition name="slide-switch">
            <div :key="activeTab" class="zw-fun-content">
              <!-- 左侧内容 -->
              <div class="zw-fun-left">
                <div class="zw-fun-title">{{ currentTabData.title }}</div>
                <div class="zw-fun-desc">{{ currentTabData.description }}</div>
                <div class="zw-fun-tags">
                  <span
                    v-for="tag in tagList"
                    :key="tag.uniqueId"
                    class="zw-fun-tag"
                  >{{ tag.tag }}</span>
                </div>
                <div class="zw-head-lf-btn">
                  <el-button
                    type="primary"
                    round
                    @click="onExperProgram"
                  >体验产品</el-button>
                  <el-button
                    style="margin-left: 32px"
                    type="primary"
                    round
                    plain
                    @click="onPresentaClick"
                  >申请演示</el-button>
                </div>
              </div>
              <!-- 右侧图片 -->
              <div class="zw-fun-right">
                <img :src="pictureBaseUrl + currentTabData.file">
                <div
                  v-if="currentTabData.phoneFile !== null && currentTabData.phoneFile !== ''"
                  class="mobile-img"
                >
                  <img :src="pictureBaseUrl + currentTabData.phoneFile">
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <!--应用场景-->
    <div class="zw-apply-scenario zw-product-matter">
      <div class="zw-matter-title">
        <img src="@/assets/image/product/fourLeft.png">
        <span>应用场景</span>
        <img src="@/assets/image/product/fourRight.png">
      </div>
      <div class="zw-matter-declare">
        {{ detailsObject.scenarioDescription }}
      </div>
      <div class="zw-apply-list">
        <div
          v-for="(item, index) in applyScenarios"
          :key="index"
          :class="['zw-apply-card', { 'zw-apply-card-expanded': activeScenario === index, 'zw-apply-card-shrinked': activeScenario !== index && activeScenario !== -1 }]"
          @mouseenter="onScenarioHover(index)"
          @mouseleave="onScenarioLeave"
        >
          <div class="zw-apply-card-header">
            <div class="zw-apply-card-title">{{ item.title }}</div>
            <div class="zw-apply-card-desc">{{ item.description }}</div>
          </div>
          <div class="zw-expanded-bottom">
            <div
              v-if="activeScenario === index"
              class="zw-head-lf-btn"
              style="width: 300px;max-width: 300px;margin-bottom: 32px"
            >
              <el-button
                style="width: 120px"
                type="primary"
                round
                @click="onExperProgram"
              >体验产品</el-button>
              <el-button
                style="margin-left: 32px;width: 120px"
                type="primary"
                round
                plain
                @click="onPresentaClick"
              >申请演示</el-button>
            </div>
            <div class="zw-apply-card-image">
              <img :src="pictureBaseUrl + item.file" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--产品优势-->
    <div class="zw-product-advantage zw-product-matter">
      <div class="zw-matter-title">
        <img src="@/assets/image/product/fourLeft.png">
        <span>产品优势</span>
        <img src="@/assets/image/product/fourRight.png">
      </div>
      <div class="zw-matter-declare">
        {{ detailsObject.advantageDescription }}
      </div>
      <div class="zw-advantage-list">
        <div v-for="(item, index) in advantages" :key="index" class="zw-advantage-card">
          <div class="zw-advantage-icon">
            <img :src="pictureBaseUrl + item.file" alt="">
          </div>
          <div class="zw-advantage-title">{{ item.title }}</div>
          <div class="zw-advantage-desc">{{ item.description }}</div>
        </div>
      </div>
    </div>
    <!--客户案例-->
    <div class="zw-client-case zw-product-matter">
      <div class="zw-matter-title">
        <img src="@/assets/image/product/fourLeft.png">
        <span>客户案例</span>
        <img src="@/assets/image/product/fourRight.png">
      </div>
      <div class="zw-matter-declare">
        {{ detailsObject.caseDescription }}
      </div>
      <div class="zw-client-scroll-wrapper">
        <div class="zw-client-scroll-shadow zw-client-scroll-shadow-left" />
        <div class="zw-client-scroll-shadow zw-client-scroll-shadow-right" />
        <vue-seamless-scroll
          :data="clients"
          :class-option="classOption"
          class="warp"
        >
          <div class="zw-client-list">
            <div
              v-for="(item, index) in clients"
              :key="'copy-' + index"
              class="zw-client-item"
            >{{ item }}</div>
          </div>
        </vue-seamless-scroll>
      </div>

      <div class="zw-client-scroll-wrapper">
        <div class="zw-client-scroll-shadow zw-client-scroll-shadow-left" />
        <div class="zw-client-scroll-shadow zw-client-scroll-shadow-right" />
        <vue-seamless-scroll
          :data="praiseImg"
          :class-option="classOption"
          class="warp"
        >
          <div class="zw-client-list">
            <div
              v-for="(item, index) in praiseImg"
              :key="'copy-' + index"
              class="zw-client-img-item"
            >
              <img :src="pictureBaseUrl + item">
            </div>
          </div>
        </vue-seamless-scroll>
      </div>
    </div>
    <!--获取解决方案-->
    <div class="zw-obtain-solution">
      <div
        class="zw-obtain-container"
        :style="{ backgroundImage:'url('+ pictureBaseUrl + bottomWebObject.file +')'}"
      >
        <div class="zw-obtain-content">
          <div class="zw-obtain-title">{{ bottomWebObject.title }}</div>
          <div class="zw-obtain-desc">{{ bottomWebObject.description }}</div>
          <div class="zw-obtain-buttons">
            <button
              class="zw-obtain-btn zw-obtain-btn-primary"
              @click="onFreeTrialClick"
            >免费体验</button>
            <button
              class="zw-obtain-btn zw-obtain-btn-secondary"
              @click="onPresentaClick"
            >预约演示</button>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
// 1. 引入 Swiper 核心和样式
import Swiper from 'swiper'
import 'swiper/css/swiper.css' // Swiper5 样式路径
import { getBottomWebList, getProductWebView } from '@/js/productModule'
import { pictureBaseUrl } from '@/utils/request'
export default {
  name: 'IntegratedEntrance',
  data() {
    return {
      pictureBaseUrl: pictureBaseUrl,
      detailsObject: {},
      list: [],
      leftValues: [],
      rightValues: [],
      painPoints: [],
      activeTab: 0,
      funTabData: [],
      applyScenarios: [],
      activeScenario: 0,
      advantages: [],
      classOption: {
        // limitMoveNum: 5,
        direction: 2
      },
      clients: [],
      praiseImg: [],
      bottomWebObject: {
        title: '',
        description: '',
        file: ''
      }

    }
  },
  computed: {
    tagList() {
      // 兜底空字符串，防止null/undefined调用split报错
      const tagStr = this.currentTabData.tag || ''
      return tagStr.split('，')
      // 去除每个标签首尾空格
        .map(tag => tag.trim())
      // 过滤空字符串，避免渲染空白标签
        .filter(tag => tag)
      // 生成带唯一id的对象，解决重复标签key冲突
        .map((tag, idx) => ({
          uniqueId: `${tag}_${idx}`,
          tag
        }))
    },
    currentTabData() {
      // 核心修改：如果funTabData为空或对应索引无数据，返回空对象兜底
      return this.funTabData[this.activeTab] || {
        title: '',
        description: '',
        file: '',
        tag: ''
      }
    }
  },
  watch: {
    // 监听路由对象
    $route: {
      handler(newVal) {
        // 路由变化重新赋值
        const id = newVal.query.id
        // 拿到新id后请求接口
        this.getProductWebView(id)
      },
      immediate: true, // 页面一进来立刻执行一次
      deep: true
    }
  },
  created() {
    this.getBottomWebList()
  },
  mounted() {
    // 2. 初始化 Swiper
    this.initSwiper()
  },
  methods: {
    // 根据id获取详情数据
    getProductWebView(id) {
      getProductWebView({ id: id }).then((res) => {
        if (res.status === 200) {
          this.detailsObject = res.data
          this.leftValues = res.data.tbProductValueDtos.slice(0, 2)
          this.rightValues = res.data.tbProductValueDtos.slice(2)
          this.list = JSON.parse(res.data.backgroundLeftFile)
          this.painPoints = res.data.tbProductDefectDtos
          this.funTabData = res.data.tbProductCoreDtos // 核心功能模块
          this.applyScenarios = res.data.tbProductUseDtos // 应用场景
          this.advantages = res.data.tbProductMeritDtos // 产品优势
          this.clients = res.data.tbProductCustomerDtos.map((item) => {
            return item.title
          }) // 客户案例
          this.praiseImg = JSON.parse(res.data.caseFile) // 客户案例图片

          // 关键：数据加载后，等待DOM更新再重新初始化Swiper
          this.$nextTick(() => {
            this.initSwiper()
          })
        }
      })
    },
    // 底部设置
    getBottomWebList() {
      getBottomWebList().then((res) => {
        if (res.status === 200) {
          this.bottomWebObject = res.data
        } else {
          this.bottomWebObject = {
            title: '',
            description: '',
            file: ''
          }
        }
      })
    },
    // 体验项目
    onExperProgram() {
      const href = this.detailsObject.address
      window.open(href, '_blank')
    },
    initSwiper() {
      new Swiper('.swiper-container', {
        loop: true, // 循环轮播
        autoplay: {
          delay: 3000, // 自动切换时间
          disableOnInteraction: false // 滑动后继续自动轮播
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.zw-swiper-next',
          prevEl: '.zw-swiper-prev'
        }
      })
    },
    // 免费体验
    onFreeTrialClick() {
      // 1. 解析出完整 URL
      const routeData = this.$router.resolve({
        path: '/IntegratedEntrance'
      })
      // 2. 新页签打开
      window.open(routeData.href, '_blank')
    },
    // 申请演示
    onPresentaClick() {
      this.$router.push({
        path: '/getScheme'
      })
    },
    // 场景卡片悬浮
    onScenarioHover(index) {
      this.activeScenario = index
    },
    // 场景卡片离开
    onScenarioLeave() {
      this.activeScenario = 0
    }
  }
}
</script>

<style>
.zw-core-center {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 40px;
}
.zw-core-image {
  width: 100%;
  height: 160px;
  object-fit: contain;
  animation: breathe 3s ease-in-out infinite;
}
@keyframes breathe {
  0% {
    transform: scale(0.9);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(0.9);
    opacity: 0.8;
  }
}

/* 核心容器：相对定位，溢出隐藏 */
.zw-fun-content-wrapper {
  overflow: hidden;
  position: relative;
  min-height: 640px;
}
/* 内容块：相对定位 */
.zw-fun-content {
  width: 100%;
  box-sizing: border-box;
  position: relative;
}
/* 新内容滑入动画：从右侧进入 */
.slide-switch-enter-active {
  transition: all 0.8s ease-in-out;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
/* 旧内容滑出动画：向左侧退出 */
.slide-switch-leave-active {
  transition: all 0.8s ease-in-out;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
/* 新内容初始状态：完全在右侧 */
.slide-switch-enter {
  transform: translateX(100%);
  opacity: 0;
}
/* 新内容结束状态：回到原位 */
.slide-switch-enter-to {
  transform: translateX(0);
  opacity: 1;
}
/* 旧内容初始状态：原位 */
.slide-switch-leave {
  transform: translateX(0);
  opacity: 1;
}
/* 旧内容结束状态：完全在左侧 */
.slide-switch-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

</style>
